// extracted by mini-css-extract-plugin
module.exports =  {"badge":"_32bbee5fda--badge--zFgLp"};